export const USER_ID_PARAM_KEY = 'demo-user-id';
export const MODE_PARAM_KEY = 'mode';
export const PROMO_CODE_PARAM_KEY = 'promocode';
export const UTM_SOURCE_PARAM_KEY = 'utm_source';
export const UTM_MEDIUM_PARAM_KEY = 'utm_medium';
export const UTM_CAMPAIGN_PARAM_KEY = 'utm_campaign';
export const UTM_CONTENT_PARAM_KEY = 'utm_content';
